module.exports = __webpack_public_path__ + "static/media/loop_touch.bde422d8.svg";